import angular from 'angular';
import PageFormDataGrid from '../../cmsCore/PagesModules/PageFormDataGrid/PageFormDataGrid';
import PageResource from '../../cmsCore/PagesModules/PageResource';
import FindFormService from './Services/FindFormService';

export default angular.module('cms.page.form.data.list', [PageFormDataGrid, PageResource, FindFormService])
    .component('pageFormDataListPage', {
        template: require('./templates/pageFormDataList.html'),
        bindings: {
            $transition$: '<'
        },
        controller: function (gettextCatalog, toastr, CONFIG, $state, PageResource, FindFormService) {
            /** @ngInject */

            this.page = {};
            this.total_count = 0;
            this.$onInit = () => {
                this.initialParams = this.$transition$.params();
                PageResource.find({id: $state.params.id},
                    response => {
                        this.page = response;
                        this.form = FindFormService.findForm(this.page.content);
                        this.columns = (this.form.config) ? this.form.config.content : [];
                    }
                );
            };

            this.onParamsChange = params => {
                delete params.page;
                $state.go('.', params, {
                    location: 'replace'
                });
            };


            this.onPageChange = page => {
                if(page === 0) {
                    return;
                }
                $state.go('.', {page:  page !== 1 ? page : undefined}, {
                    location: 'replace'
                });
            };

        }
    }).name;




// WEBPACK FOOTER //
// ./src/cmsPages/Pages/PageFormDataListPage.js